import { HttpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { SearchTeamPipe } from './pipes/searchTeam/searchTeam.pipe';
import { LoadingComponent } from './reusable/loading/loading.component';
import { TicketDraftComponent } from './reusable/ticket-draft/ticket-draft.component';
import { ChatComponent } from './reusable/chat/chat.component';
import { SubHeaderComponent } from './reusable/sub-header/sub-header.component';
import { MatComponentsModule } from 'app/modules/mat-components/mat-components.module';
import { TeamUiComponent } from './reusable/team-ui/team-ui.component';
import { ConnectTeamAccountComponent } from './reusable/connect-team-account/connect-team-account.component';
import { ChooseUploadPlanComponent } from './reusable/choose-upload-plan/choose-upload-plan.component';
import { ChargeCardComponent } from './reusable/charge-card/charge-card.component';
import { LeaderChargeCardComponent } from './reusable/leader-charge-card/leader-charge-card.component';
import { GroupUiComponent } from './reusable/group-ui/group-ui.component';
import { ViewScheduleComponent } from './reusable/view-schedule/view-schedule.component';
import { UserProfileComponent } from './reusable/user-profile/user-profile.component';
import { TeamAccountComponent } from './reusable/team-account/team-account.component';
import { SearchGamePipe } from './pipes/searchGame/searchGame.pipe';
import { ChooseSeatSelectionComponent } from './reusable/choose-seat-selection/choose-seat-selection.component';
import { ViewDetailComponent } from './reusable/view-detail/view-detail.component';
import { StipeConnectComponent } from './reusable/stipe-connect/stipe-connect.component';
import { SubFooterComponent } from './reusable/sub-footer/sub-footer.component';
import { ConfirmPrivacyModalComponent } from './reusable/confirm-privacy-modal/confirm-privacy-modal.component';
import { PreviewDraftComponent } from 'shared/reusable/preview-draft/preview-draft.component';
import { SetGamesModal } from 'shared/reusable/set-games-modal/set-games-modal.component';
import { SubscriptionHomeComponent } from 'app/modules/group/components/subscription-home/subscription-home.component';
import { PackagePreviewComponent } from 'shared/reusable/package-preview/package-preview.component';
import { ConnectTicketmasterModal } from './reusable/connect-tm/connect-tm.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HttpModule,
    MatComponentsModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    LoadingComponent,
    ChatComponent,
    MatComponentsModule,
    SubHeaderComponent,
    TeamUiComponent,
    GroupUiComponent,
    SubFooterComponent
  ],
  declarations: [
    LoadingComponent,
    SearchTeamPipe,
    SearchGamePipe,
    TicketDraftComponent,
    ConnectTeamAccountComponent,
    ChooseUploadPlanComponent,
    ChatComponent,
    SubHeaderComponent,
    TeamUiComponent,
    GroupUiComponent,
    LeaderChargeCardComponent,
    ChargeCardComponent,
    UserProfileComponent,
    TeamAccountComponent,
    ViewScheduleComponent,
    PreviewDraftComponent,
    SetGamesModal,
    PackagePreviewComponent,
    ChooseSeatSelectionComponent,
    ViewDetailComponent,
    SubscriptionHomeComponent,
    ConnectTicketmasterModal,
    StipeConnectComponent,
    SubFooterComponent,
    ConfirmPrivacyModalComponent,
  ],
  entryComponents: [
    ViewScheduleComponent,
    PreviewDraftComponent,
    SetGamesModal,
    PackagePreviewComponent,
    ConfirmPrivacyModalComponent,
    ConnectTicketmasterModal
  ],
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts